import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23c96b88"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "zhezhao"
}
const _hoisted_2 = { class: "ub ub-ac ub-pc fw title" }
const _hoisted_3 = { class: "ub ub-ac ub-ps sub-title" }
const _hoisted_4 = { class: "ub ub-ac ub-ps sub-title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 最新进度填报日期： ")
const _hoisted_6 = { class: "ub ub-ac ub-ps sub-title" }
const _hoisted_7 = { class: "ub ub-ac ub-ps sub-title" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 最新进度填报： ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps sub-title" }, [
  /*#__PURE__*/_createTextVNode(" 计划工期："),
  /*#__PURE__*/_createElementVNode("span", { class: "plan-color-span" })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps sub-title" }, [
  /*#__PURE__*/_createTextVNode(" 正常推进："),
  /*#__PURE__*/_createElementVNode("span", { class: "advance-color-span" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps sub-title" }, [
  /*#__PURE__*/_createTextVNode(" 滞后推进/延期中："),
  /*#__PURE__*/_createElementVNode("span", { class: "advance-color-span bg1" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps sub-title" }, [
  /*#__PURE__*/_createTextVNode(" 提前启动/超前推进："),
  /*#__PURE__*/_createElementVNode("span", { class: "advance-color-span bg2" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps sub-title" }, [
  /*#__PURE__*/_createTextVNode(" 正常完成："),
  /*#__PURE__*/_createElementVNode("span", { class: "plan-color-span-block" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps sub-title" }, [
  /*#__PURE__*/_createTextVNode(" 延期完成："),
  /*#__PURE__*/_createElementVNode("span", { class: "plan-color-span-block bg1" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps sub-title" }, [
  /*#__PURE__*/_createTextVNode(" 超前完成："),
  /*#__PURE__*/_createElementVNode("span", { class: "plan-color-span-block bg2" })
], -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("去掉法定节假日 ")
const _hoisted_18 = { style: {"cursor":"pointer","color":"rgba(0, 0, 0, 0.45)"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("双休制")
const _hoisted_20 = {
  key: 0,
  class: "ub fw ub-ac zhezhao2"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "pl5"
}
const _hoisted_23 = {
  key: 0,
  class: "pl5"
}
const _hoisted_24 = { class: "pl5" }
const _hoisted_25 = { class: "pl5" }
const _hoisted_26 = {
  key: 0,
  class: "ub fw plan-color-progress"
}
const _hoisted_27 = {
  key: 2,
  class: "curr-day"
}
const _hoisted_28 = {
  key: 3,
  class: "rest-day"
}

export function render(_ctx, _cache) {
  const _component_a_col = _resolveComponent("a-col")
  const _component_ant_icon = _resolveComponent("ant-icon")
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_vxe_column = _resolveComponent("vxe-column")
  const _component_vxe_colgroup = _resolveComponent("vxe-colgroup")
  const _component_vxe_table = _resolveComponent("vxe-table")
  const _component_hmd_list_page = _resolveComponent("hmd-list-page")

  return (_openBlock(), _createBlock(_component_hmd_list_page, { class: "list-page" }, {
    body: _withCtx(() => [
      (_ctx.displayQuanping)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["ub ub-ac ub-ps ub-ver progress", _ctx.displayQuanping?'quanping':''])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.planData?.projectName), 1),
        _createVNode(_component_a_row, { class: "ub ub-ac ub-pc fw" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 6 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, "项目编号：" + _toDisplayString(_ctx.planData?.projectBizNo), 1),
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString(_ctx.planData?.lastWriteDate), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, "工程合同： " + _toDisplayString(_ctx.planData?.contractName), 1),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.planData?.lastWriteBizNo)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "ml-auto",
                        href: "javascript:void(0)",
                        onClick: _cache[0] || (_cache[0] = $event => (_ctx.goto()))
                      }, _toDisplayString(_ctx.planData?.lastWriteBizNo), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_9
                      ], 64))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 3 }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 4 }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 3 }, {
              default: _withCtx(() => [
                _hoisted_14,
                _hoisted_15,
                _hoisted_16
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 3 }, {
              default: _withCtx(() => [
                (_ctx.planData?.excludeHolidays==1)
                  ? (_openBlock(), _createBlock(_component_a_checkbox, {
                      key: 0,
                      checked: _ctx.planData?.excludeHolidays==1,
                      disabled: true,
                      class: "wauto"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _createVNode(_component_a_tooltip, {
                          trigger: "hover",
                          placement: "top",
                          class: "append-to-body",
                          "arrow-point-at-center": ""
                        }, {
                          title: _withCtx(() => [
                            _createTextVNode(" 国务院办公厅尚未发布“" + _toDisplayString((new Date()).getFullYear()+1) + "年度法定节假日安排”通知；跨年施工计划，其“甘特图”、“工期”和“计划进度”统计可能存在差异，请知晓。 ", 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_18, [
                              _createVNode(_component_ant_icon, { type: "QuestionCircleOutlined" })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["checked"]))
                  : _createCommentVNode("", true),
                (_ctx.planData?.restType==1)
                  ? (_openBlock(), _createBlock(_component_a_checkbox, {
                      key: 1,
                      checked: _ctx.planData?.restType==1,
                      disabled: true,
                      class: "wauto"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }, 8, ["checked"]))
                  : _createCommentVNode("", true),
                (_ctx.planData?.restType==2)
                  ? (_openBlock(), _createBlock(_component_a_checkbox, {
                      key: 2,
                      checked: _ctx.planData?.restType==2,
                      disabled: true,
                      class: "wauto"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("单休制(" + _toDisplayString(_ctx.planData?.singleRestDay==6?'周六':'周日') + ")", 1)
                      ]),
                      _: 1
                    }, 8, ["checked"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.loading||_ctx.comLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.loading||_ctx.comLoading,
                class: "ub spin-loading"
              }, null, 8, ["spinning"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_vxe_table, {
          class: "fw responsive-table a-table gantt-table",
          border: "",
          ref: "tableRef",
          "header-cell-class-name": _ctx.headerCellClassName,
          height: _ctx.tableHeight,
          data: _ctx.tableData,
          "row-config": {keyField: 'uuid'},
          "tree-config": {rowField: 'uuid', parentField: 'parentId',expandAll: true},
          "scroll-x": {enabled: true},
          "seq-config": {seqMethod: _ctx.seqMethod }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vxe_column, {
              type: "seq",
              width: "60",
              title: "序号",
              align: "center",
              fixed: "left"
            }),
            _createVNode(_component_vxe_column, {
              "show-overflow": "",
              width: "200",
              align: "left",
              "tree-node": "",
              title: "分组/任务名称",
              fixed: "left"
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(row?.groupName?row?.groupName:row?.content), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "progressStatusName",
              align: "left",
              width: "70",
              title: "进度状态",
              fixed: "left"
            }),
            _createVNode(_component_vxe_column, {
              field: "planCount",
              align: "left",
              width: "70",
              title: "工程量"
            }, {
              default: _withCtx(({row}) => [
                (row.parentId!='0')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(row?.planCount), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "unit",
              align: "left",
              width: "70",
              title: "结算单位"
            }, {
              default: _withCtx(({row}) => [
                (row.parentId!='0')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(row?.unit=='task'?'任务':row?.unit), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "actualCount",
              align: "left",
              width: "70",
              title: "已完成工程量"
            }, {
              default: _withCtx(({row}) => [
                (row.parentId!='0')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(row?.actualCount), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "planProgress",
              align: "left",
              width: "70",
              title: "计划进度（%）"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", _hoisted_24, _toDisplayString(row?.planProgress) + "% ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "actualProgress",
              align: "left",
              width: "70",
              title: "实际进度（%）"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("span", _hoisted_25, _toDisplayString(row?.actualProgress) + "% ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_column, {
              field: "planStartDate",
              align: "left",
              width: "110",
              title: "计划开始日期"
            }),
            _createVNode(_component_vxe_column, {
              field: "planEndDate",
              align: "left",
              width: "110",
              title: "计划完成日期"
            }),
            _createVNode(_component_vxe_column, {
              field: "planUseDay",
              align: "left",
              width: "80",
              title: "计划工期"
            }),
            _createVNode(_component_vxe_column, {
              field: "actualStartDate",
              align: "left",
              width: "110",
              title: "实际开始日期"
            }),
            _createVNode(_component_vxe_column, {
              field: "actualEndDate",
              align: "left",
              width: "110",
              title: "实际完成日期"
            }),
            _createVNode(_component_vxe_column, {
              field: "actualUseDays",
              align: "left",
              width: "80",
              title: "实际工期"
            }),
            _createVNode(_component_vxe_colgroup, {
              title: "施工时间/天",
              align: "center"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerTh, (item, index) => {
                  return (_openBlock(), _createBlock(_component_vxe_colgroup, {
                    title: item.title,
                    align: "center",
                    "min-width": "28"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (o, i) => {
                        return (_openBlock(), _createBlock(_component_vxe_column, {
                          title: o.day+'',
                          align: "center",
                          "min-width": item.children.length<2?64:28
                        }, {
                          default: _withCtx(({ row }) => [
                            (new Date(item.title+'-'+o.str)>=new Date(row.planStartDate)&&new Date(item.title+'-'+o.str)<=new Date(row.planEndDate))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                              : _createCommentVNode("", true),
                            (new Date(item.title+'-'+o.str)>=new Date(row.actualWriteDateList[0])&&new Date(item.title+'-'+o.str)<=new Date(row.actualWriteDateList[row.actualWriteDateList.length-1]))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  ((item.title+'-'+o.str)==row.actualWriteDateList[row.actualWriteDateList.length-1])
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["ub fw has-arrow", 'actual-color-progress'+(row.progressStatus-1)])
                                      }, null, 2))
                                    : _createCommentVNode("", true),
                                  ((item.title+'-'+o.str)!=row.actualWriteDateList[row.actualWriteDateList.length-1])
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: _normalizeClass(["ub fw", 'actual-color-progress'+(row.progressStatus-1)])
                                      }, null, 2))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.isToday(item.title+'-'+o.str))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                              : _createCommentVNode("", true),
                            (!_ctx.isRest(item.title+'-'+o.str))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["title", "min-width"]))
                      }), 256))
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["header-cell-class-name", "height", "data", "seq-config"])
      ], 2)
    ]),
    _: 1
  }))
}